import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  inject,
  Input,
  Output,
} from '@angular/core';
import {
  selectBookmarkedIcon,
  selectBookmarkIcon,
} from '@epicuro-next/platform/configuration';
import { select, Store } from '@ngrx/store';

@Component({
  selector: 'atx-bookmark-button',
  templateUrl: './bookmark-button.component.html',
  styleUrls: ['./bookmark-button.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class BookmarkButtonComponent {
  private readonly store = inject(Store);

  /** Determines to show add bookmark or remove bookmark button */
  @Input() public showAddBookmarkButton: boolean;

  @Input() public isBookmarking = false;

  /** Event emitter for when the user clicks on add bookmark button */
  @Output() public addBookmarkClicked = new EventEmitter();

  /** Event emitter for when the user clicks on remove bookmark button */
  @Output() public removeBookmarkClicked = new EventEmitter();

  public bookmarkIcon$ = this.store.pipe(select(selectBookmarkIcon));
  public bookmarkedIcon$ = this.store.pipe(select(selectBookmarkedIcon));
}
